export const SIGN_UP_COMPLETED = "users/signUpCompleted";
export const LOGIN_COMPLETED = "users/loginCompleted";
export const LOGOUT_COMPLETED = "users/logoutCompleted";
export const FIND_ROLE_BY_CODE_COMPLETED = "users/findRoleByCodeCompleted";
export const FIND_ALL_ROLES_COMPLETED = "users/findAllRolesCompleted";
export const CREATE_USER_COMPLETED = "users/createUserCompleted";
export const FIND_TOTAL_USER_ACCOUNT_COMPLETED = "users/findTotalUserAccountCompleted";
export const LOCK_USER_ACCOUNT_COMPLETED = "users/lockUserAccountCompleted";